<script lang="ts">
    import { navigate } from "svelte-routing"
    import { i18n, sprache } from "../store"

    let value = ""
</script>

<form
    on:submit|preventDefault="{() => {
        navigate({ de: '/de/suche', en: '/en/search' }[$sprache] + '?q=' + encodeURIComponent(value))
    }}"
>
    <input type="text" bind:value="{value}" placeholder="{$i18n('Suche')}" />
    <button type="submit" class="icon searchbutton">Suchen</button>
</form>
